import script from "./AuthenticationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthenticationView.vue?vue&type=script&setup=true&lang=ts"

import "./AuthenticationView.vue?vue&type=style&index=0&id=ef9329bc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef9329bc"]])

export default __exports__